
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";

export default class PageRoot extends WBComponent{

    constructor(){
        super();
        this.typename = wBComponentTypeNames.pageRoot;

    }
    RenderLayout({component,children}:WBRenderProps): JSX.Element {

       
        let pageType = getNodeComponentAttributeValue(component,"pageType","");

        let classAdd = "";
        if(pageType == "blog"){
            classAdd = "blog-page-root";
        }

        let newStyle:{} = component.children.length == 2 ? {cursor:"default",display:"flex",flexDirection:"column",justifyContent:"space-between"}:{cursor:"default"}
        return <div className={"hierarchy v-page-root "+classAdd} style={newStyle}id={component.id}>
            
            {children}
            {component.children.length == 2 && <div className="click-to-start"></div>}
            </div>
    }

}